import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import styles from './style.module.less';

const name = <FormattedMessage {...messages.bundleColumnHeader} />;
const checkmarkIcon = <FontAwesomeIcon className={styles['active-checkmark']} icon={faCheck} />;

export default {
  getMessageDescriptor: () => messages.bundleColumnHeader,
  name,
  render: (data) => {
    return data.isBundle ? checkmarkIcon : '';
  },
};
